<template>
    <div class="maquinas-admin">
        <div class="tituloCadastroFormFront">Gestão de Frota, Máquinas e Equipamentos</div>
        <hr>
        <b-form>
            <input id="maquina-id" type="hidden" v-model="maquina.id" />

            <b-row>
                <b-col xs="12">
                    <b-form-group label="Nome do Equipamento:" label-for="maquina-name">
                        <b-form-input id="maquina-name" type="text"
                            v-model="maquina.nome" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o Nome do Equipamento..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col xs="12">
                    <b-form-group label="Modelo do Equipamento:" label-for="maquina-modelo">
                        <b-form-input id="maquina-modelo" type="text"
                            v-model="maquina.modelo" required
                            :readonly="mode === 'remove'"
                            placeholder="Informe o Modelo do Equipamento..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col xs="12">
                    <b-form-group label="Bateria Associada:" label-for="maquina-bateriaId">
                        <b-form-input id="maquina-bateria" type="text"
                            v-model="maquina.bateriaId" required
                            :readonly="mode === 'remove'"
                            placeholder="Associe este equipamento com uma Bateria Inteligente Hion." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col xs="12">
                    <b-button variant="primary" v-if="mode === 'save'"
                        @click="save">Salvar</b-button>
                    <b-button variant="danger" v-if="mode === 'remove'"
                        @click="remove">Excluir</b-button>
                    <b-button class="ml-2" @click="reset">Cancelar</b-button>
                </b-col>
            </b-row>

        </b-form>

        <hr>

        <b-table hover striped :items="maquinas" :fields="fields">
            <template v-slot:cell(actions)="data">
                <b-button variant="warning" @click="loadMaquina(data.item)" class="mr-2">
                    <i class="fas fa-pen-alt"></i>
                </b-button>
                <b-button variant="danger" @click="loadMaquina(data.item, 'remove')">
                    <i class="fas fa-trash-alt"></i>
                </b-button>
            </template>
        </b-table>

    </div>
</template>

<script>
import { baseApiUrl, showError } from '../../../global'
import axios from 'axios'

export default {
    name: 'MaquinasAdmin',
    data: function() {
        return {
            mode: 'save',
            maquina: {},
            maquinas: [],
            fields: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'modelo', label: 'Modelo do Equipamento', sortable: true },
                { key: 'bateriaId', label: 'Código da Bateria Associada', sortable: true },
                { key: 'actions', label: 'Ações' }
            ]
        }
    },
    methods: {
        loadMaquinas() {
            const url = `${baseApiUrl}/maquinas`
            axios.get(url).then(res => {
                this.maquinas = res.data
            })
        },
        save(evt) {
            evt.preventDefault()

            if(this.maquina.nome === undefined) {
               alert('Por favor insira o Nome do equipamento')
               return
            }
            if(this.maquina.modelo === undefined) {
               alert('Por favor insira o Modelo do equipamento')
               return
            }
            if(this.maquina.bateriaId === undefined) {
               alert('Por favor insira o código de associação com uma Bateria Inteligente Hion!')
               return
            }

            const method = this.maquina.id ? 'put' : 'post'
            const id = this.maquina.id ? `/${this.maquina.id}` : ''
            axios[method](`${baseApiUrl}/maquinas${id}`, this.maquina)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
            //alert(JSON.stringify(this.usuario))
            setTimeout(function(){
                this.loadMaquinas()
            }, 5000);
        },
        reset() {
            this.mode = 'save'
            this.maquina = {}
            this.loadmaquinas()
        },
        remove() {
            const id = this.maquina.id
            axios.delete(`${baseApiUrl}/maquinas/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
            
            setTimeout(function(){
                this.loadMaquinas()
            }, 5000);
        },
        loadMaquina(maquina, mode = 'save') {
            this.mode = mode;
            this.maquina = { ...maquina };
        }
    },
    mounted() {
        this.loadMaquinas()
    }
}
</script>

<style>